import * as Sentry from '@sentry/browser';

export const HOST = process.env.REACT_APP_API_HOST;

export function genOptions(method, data, extraHeaders) {
  method = method.toUpperCase();
  //get locale/language from localstorage to set in accept language header
  const locale = localStorage.getItem('locale');
  const headers = {
    Accept: 'application/json',
    'Content-Type': 'application/json',
    ...(locale ? { 'Accept-Language': locale } : undefined),
    ...extraHeaders,
  };

  let options = { headers, method };

  if (['PUT', 'POST', 'PATCH'].indexOf(method) !== -1) {
    if (headers['Content-Type'] !== 'application/x-www-form-urlencoded') {
      options.body = JSON.stringify(data);
    } else {
      options.body = '';
    }
  }
  return options;
}

export function route(path) {
  if (path.indexOf('/') === 0) {
    path = `${HOST}${path}`;
  }

  return path;
}

export function fetchRequest(url, options, errorIdentifier) {
  return fetch(url, options)
    .then(isSuccessful)
    .then(getJson)
    .catch(error => reportCrash(error, errorIdentifier));
}

async function reportCrash(error, identifier) {
  const text = await error.response
    .text()
    .catch(() => '{"errors": [{"message": ""}]}');
  let message = '';
  let sentryIgnore = false;
  try {
    message = JSON.parse(text)
      .errors.map(err => err.message)
      .join(' ');
    sentryIgnore = JSON.parse(text).sentry_ignore;
  } catch (err) {
    message = err;
  }

  error.sentryIgnore = sentryIgnore;
  error.message = message;

  if (process.env.NODE_ENV === 'production') {
    if (!error.sentryIgnore) {
      Sentry.withScope(scope => {
        scope.setFingerprint(['{{ default }}', identifier]);
        Sentry.captureException(`${message} - ${JSON.stringify(error)}`);
      });
    }
  } else {
    console.error('Error occurred in development: ', error);
    console.error(`${message} - ${JSON.stringify(error)}`);
  }

  return Promise.reject(error);
}

function ResponseException(response) {
  this.message = 'API response is not ok';
  this.status = response.status;
  this.response = response;
}

export function isSuccessful(response) {
  if ([200, 201, 204].indexOf(response.status) === -1) {
    throw new ResponseException(response);
  }

  return response;
}

export function getJson(response) {
  if (
    response.status === 204 ||
    (response.status === 201 && response._bodyText === '')
  ) {
    return true;
  } else {
    return response.json();
  }
}
export function setLanguage(language) {
  const url =
    process.env.NODE_ENV === 'production'
      ? 'https://fixt.co/requests'
      : 'http://localhost:8000';

  let head = new Headers();
  head.set('Accept-Language', `${language}`);

  const requestOptions = {
    method: 'POST',
    headers: head,
  };
  fetch(url, requestOptions)
    .then(response => response.status)
    .catch(err => console.warn(err));
}
